module.exports = __webpack_public_path__ + "static/media/hero_desktop.965ae53e.webp";